import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
  static values = {
    direction: String,
    changeDirectionPoint: Number,
    position: String
  }
  static classes = [
    "hideInformation",
    "hideSearch",
    "open",
    "searchOpen",
    "shrunk",
    "stuck",
    "submenuVisible"
  ]

  initialize() {
    this.lastScroll = window.scrollY
    this.shrinkPoint = 100
  }

  connect() {
    useClickOutside(this)
    if (window.scrollY > this.changeDirectionPointValue) this.directionBottom()
  }

  directionTop() {
    if (this.directionValue === "top") return
    this.directionValue = "top"
  }

  directionBottom() {
    if (this.directionValue === "bottom") return
    this.directionValue = "bottom"
  }

  stuck() {
    this.element.classList.add(this.stuckClass)
  }

  unstuck() {
    this.element.classList.remove(this.stuckClass)
  }

  hideSearch() {
    this.element.classList.add(this.hideSearchClass)
  }

  showSearch() {
    this.element.classList.remove(this.hideSearchClass)
  }

  hideInformation() {
    this.element.classList.add(this.hideInformationClass)
  }

  showInformation() {
    this.element.classList.remove(this.hideInformationClass)
  }

  clickOutside() {
    this.close()
  }

  toggle() {
    this.element.classList.toggle(this.openClass)
  }

  open() {
    this.element.classList.add(this.openClass)
  }

  close() {
    this.element.classList.remove(this.openClass)
  }

  shrink() {
    if (!this.isSubmenuVisible) return
    if (!this.isPositionTop) return
    const currentScroll = window.scrollY
    const isPastShrinkPoint = currentScroll > this.shrinkPoint
    const isAtTop = currentScroll <= 100
    const isScrollingDown = currentScroll > this.lastScroll
    if (isScrollingDown && isPastShrinkPoint) {
      requestAnimationFrame(() => this.toggleShrunkClass(true))
    } else if (isAtTop) {
      requestAnimationFrame(() => this.toggleShrunkClass(false))
    }
    this.lastScroll = currentScroll
  }

  toggleShrunkClass(toggle) {
    this.element.classList.toggle(this.shrunkClass, toggle)
  }

  onSearchToggle(event) {
    this.element.classList.toggle(this.searchOpenClass, event.detail.open)
  }

  get isSubmenuVisible() {
    return this.element.classList.contains(this.submenuVisibleClass)
  }

  get isPositionTop() {
    return this.positionValue === "top"
  }
}
